module.exports = __webpack_public_path__ + "img/buy-one.648d61e5.svg";